<p-toast role="status" aria-live="polite" aria-atomic="true"></p-toast>
<p-confirmDialog role="alertdialog" aria-modal="true"></p-confirmDialog>

<div class="checklist-registry-container">
  <!-- Breadcrumb -->
  <nav class="mb-4" aria-label="Breadcrumb">
    <p-breadcrumb
      styleClass="custom-breadcrumb"
      [model]="breadcrumbItems()"
      [home]="{ icon: 'pi pi-home', routerLink: '/axa/professionals-dashboard' }"
    >
    </p-breadcrumb>
  </nav>

  <!-- Page Header -->
  <section class="page-header" aria-labelledby="page-title">
    <div class="header-content">
      <div class="header-left">
        <i class="pi pi-check-square header-icon" aria-hidden="true"></i>
        <div class="header-text">
          <h1 id="page-title">Gestione Checklist</h1>
          <p class="subtitle">Configurazione e monitoraggio delle checklist</p>
        </div>
      </div>
    </div>
  </section>

  <!-- Custom Toolbar for Show Deleted Toggle -->
  <div class="custom-toolbar mb-4">
    <div class="flex justify-content-between align-items-center">
      <div class="flex align-items-center gap-2">
        <label for="showDeletedChecklist" class="text-sm font-medium text-700">Mostra Eliminati</label>
        <p-toggleSwitch
          inputId="showDeletedChecklist"
          [(ngModel)]="showDeleted"
          (onChange)="onShowDeletedChange()"
          [attr.aria-label]="'Mostra checklist eliminate'"
        />
      </div>
    </div>
  </div>

  <!-- Reusable Table Component -->
  <app-registry-table
    [title]="tableTitle"
    [icon]="tableIcon"
    [columns]="columns"
    [data]="data()"
    [loading]="loading()"
    [showClearFiltersButton]="true"
    [ignoreStatusChecks]="true"
    (onEditClick)="onEditClick($event)"
    (onDeleteClick)="onDeleteClick($event)"
    (onClearFilters)="onClearFilters()"
  />
</div>
